import React from 'react';

import SALTA from '../../../../assets/swiss-medical-center/centro_odontologico_salta.jpg';
import Image from '../../../Commons/Image/Image';

import styles from './SaltaOdontoCenter.module.scss';

const SaltaOdontoCenter = () => {
  return (
    <div className={styles.salta_odonto_center}>
      <h3>Swiss Medical Center Salta</h3>
      <p>
        <strong className={styles.salta_odonto_center__redText}>Dirección: </strong>España 943, Piso
        4°, Salta
      </p>
      <p>
        <strong className={styles.salta_odonto_center__redText}>Turnos: </strong>(0387) 4215033 |
        Interno 150 | 0810-333-8876
      </p>
      <Image
        src={SALTA}
        alt='Swiss Medical Center Salta'
        title='Swiss Medical Swiss Medical Center Salta'
        classes={styles.salta_odonto_center__image}
      />
      <p>
        <strong>Especialidades</strong>
      </p>
      <ul>
        <li>Guardia odontológica 12 horas</li>
        <li>Odontología general</li>
        <li>Odontopediatria</li>
        <li>Endodoncia</li>
        <li>Periodoncia</li>
        <li>Ortodoncia para menores y adultos</li>
        <li>Implantes dentales</li>
        <li>Prótesis sobre implantes</li>
        <li>Blanqueamiento dental</li>
        <li>Prótesis dentales</li>
      </ul>
      <p>
        <strong className={styles.salta_odonto_center__redText}>Días y horarios de atención</strong>
      </p>
      <p>Lunes a Viernes | 08 hs. a 20 hs.</p>
      <p>Sábados | 08 hs. a 14 hs.</p>
    </div>
  );
};

export default SaltaOdontoCenter;
